import { Component, Prop, Vue } from 'vue-property-decorator';
import { getComponentProps } from '@/utils/vueUtils';

import { SearchSuggestionsViewModel } from './SearchSuggestions.types';
import SearchResultsList from '@/components/SearchResultsList/SearchResultsList.vue';
import LinkItem from '@/common/interfaces/LinkItem';

const SearchSuggestionsProps = Vue.extend({
  props: getComponentProps<SearchSuggestionsViewModel>({
    Title: 'Placeholder Search Suggestions Title',
    Items: [],
  }),
});

@Component({
  components: {
    SearchResultsList,
  },
})
export default class SearchSuggestions extends SearchSuggestionsProps {
  @Prop() readonly SearchCta: LinkItem;
  handleClick(data) {
    this.$emit('selected', data);
  }
}
